export default __webpack_public_path__ + "static/media/datastream.df487c19.svg";